import * as React from 'react';
const classNames = require('classnames');

interface Props {
	title?: {};
	className?: string;
	isCentered?: boolean;
	children?: {};
}

const PageHeader: React.StatelessComponent<Props> = ({ title, className, isCentered, children }) => {
	return (
		<header className={classNames('page-header mb-4 mb-md-5', className)}>
			<div className="row">
				<div className={`col-md-8${isCentered ? ' mx-auto text-md-center' : ''}`}>
					{title && <h1 className={`page-header-title ${children ? '' : ' mb-0'}`}>{title}</h1>}
					{children}
				</div>
			</div>
		</header>
	);
};

export default PageHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/PageHeader.tsx